import {EventEmitter} from 'events';

let audioContext;

export function setAudioContext(_audioContext) {
    audioContext = _audioContext;
}

class AudioAnalyser extends EventEmitter {
    initialized = false;

    initialize() {
        if (this.initialized) return;
        this.initialized = true;

        this.analyserNode = audioContext.createAnalyser();
        this.analyserNode.connect(audioContext.destination);

        this.analyserNode.fftSize = 512;
        const bufferLength = this.analyserNode.frequencyBinCount;
        this.dataArray = new Uint8Array(bufferLength);

        setInterval(this.emitData, 100);
    }

    emitData = () => {
        this.analyserNode.getByteTimeDomainData(this.dataArray);
        this.emit('data', this.dataArray);
    };

    setAudioSourceNode(sourceNode) {
        if (this.sourceNode) {
            this.sourceNode.disconnect();
        }

        this.sourceNode = sourceNode;
        this.sourceNode.connect(this.analyserNode);
    }
}

export default new AudioAnalyser();
